export const dateCompareDesc = (dateField) => (a, b) => {
  return new Date(b[dateField]) - new Date(a[dateField]);
};

export const substractMonts = (date, months) => {
  return new Date(date.setMonth(date.getMonth() - months));
};
